import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import { applyTheme, readTheme, type Theme } from '@/lib/theme'

type Ctx = { theme: Theme; setTheme: (next: Theme) => void }
const ThemeContext = createContext<Ctx>({ theme: 'system', setTheme: () => {} })

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(() => readTheme())
  const setTheme = useCallback((next: Theme) => {
    setThemeState(next)
    applyTheme(next)
  }, [])
  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
}

export function useTheme(): Ctx {
  return useContext(ThemeContext)
}
